var __webpack_error__ = new Error();
module.exports = new Promise(function(resolve, reject) {
	if(typeof sensorsToAddressApp !== "undefined") return resolve();
	__webpack_require__.l("https://devices.iotans.by/ui/sensors-to-address/remoteEntry.js", function(event) {
		if(typeof sensorsToAddressApp !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "sensorsToAddressApp");
}).then(function() { return sensorsToAddressApp; });